module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-6-zoom.010b19e7.png";